import * as organizationConstants from '../constants/organizations';

export function invitationsByOrg(state = {}, action) {
    switch (action.type) {
        case organizationConstants.FETCH_ORGANIZATION_MEMBER_INVITATIONS_SUCCESS:
        case organizationConstants.FETCH_ORGANIZATION_MEMBER_INVITATIONS_FAILURE: {
            const { invitations, organizationId } = action.payload;
            return {
                ...state,
                [organizationId]: invitations,
            };
        }
        case organizationConstants.INVITE_ORGANIZATION_MEMBER_SUCCESS: {
            const { invitation, organizationId } = action.payload;
            return {
                ...state,
                [organizationId]: [invitation, ...state[organizationId]],
            };
        }
        case organizationConstants.REVOKE_ORGANIZATION_MEMBER_INVITATIONS_SUCCESS: {
            const { invitationId, organizationId } = action.payload;
            const invitations = [...state[organizationId]].filter(
                invitation => invitation.id !== invitationId,
            );
            return {
                ...state,
                [organizationId]: invitations,
            };
        }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/invitationsReducer.js